
import {} from '/home/sysadmin/zretel_web/shared/bundle/ruby/2.7.0/gems/cookies_eu-1.7.8/app/assets/javascripts/cookies_eu.js'
import {} from '/home/sysadmin/zretel_web/shared/bundle/ruby/2.7.0/bundler/gems/best_in_place-88eb3052623a/lib/assets/javascripts/best_in_place.js'
